module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/logo/logo-full-428.png"+" 428w",
        images: [{path: __webpack_public_path__ + "assets/images/logo/logo-full-428.png",width: 428,height: 150}],
        src: __webpack_public_path__ + "assets/images/logo/logo-full-428.png",
        toString: function(){return __webpack_public_path__ + "assets/images/logo/logo-full-428.png"},
        
        width: 428,
        height: 150
      }